/**
 * RelatedLinks Component
 * Internal linking için otomatik ilgili sayfa önerileri
 * Pillar-Cluster SEO stratejisi için tasarlandı
 */

import Link from "next/link";
import { ArrowRight } from "lucide-react";

// Sayfa türlerine göre ilişkilendirme haritası
const linkMap = {
  // Pillar sayfalar -> Cluster'lar
  pillar: {
    "ik-yazilimi": [
      { href: "/cozumler/ise-alim", label: "İşe Alım Çözümü" },
      { href: "/cozumler/calisan-yonetimi", label: "Çalışan Yönetimi" },
      { href: "/cozumler/izin-yonetimi", label: "İzin Yönetimi" },
      {
        href: "/blog/dijital-ik-donusumu-rehberi",
        label: "Dijital İK Rehberi",
      },
    ],
  },

  // Çözüm sayfaları -> İlgili araçlar ve blog
  solution: {
    "ise-alim": [
      { href: "/yazilim/ats-yazilimi", label: "ATS Yazılımı" },
      { href: "/yazilim/cv-analiz-programi", label: "CV Analiz Programı" },
      {
        href: "/araclar/ise-alim-suresi-hesaplayici",
        label: "Time-to-Hire Hesaplayıcı",
      },
      { href: "/blog/cv-analizi-nasil-yapilir", label: "CV Analizi Rehberi" },
    ],
    "calisan-yonetimi": [
      { href: "/yazilim/hris-yazilimi", label: "HRIS Yazılımı" },
      {
        href: "/yazilim/personel-yonetimi-yazilimi",
        label: "Personel Yönetimi",
      },
      {
        href: "/blog/dijital-ik-donusumu-rehberi",
        label: "Dijital İK Rehberi",
      },
    ],
    "izin-yonetimi": [
      { href: "/yazilim/izin-takip-programi", label: "İzin Takip Programı" },
      { href: "/araclar/izin-hesaplayici", label: "İzin Hesaplayıcı" },
      { href: "/blog/izin-yonetimi-rehberi", label: "İzin Yönetimi Rehberi" },
    ],
    bordro: [
      { href: "/yazilim/bordro-yazilimi", label: "Bordro Yazılımı" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
      { href: "/yazilim/maas-hesaplama-programi", label: "Maaş Hesaplama" },
    ],
    "performans-yonetimi": [
      {
        href: "/yazilim/performans-degerlendirme-yazilimi",
        label: "Performans Yazılımı",
      },
      {
        href: "/blog/performans-degerlendirme-optimize-etme",
        label: "Performans Rehberi",
      },
    ],
    analitik: [
      { href: "/sektorler/finans", label: "Finans Sektörü İK" },
      { href: "/cozumler/360-feedback", label: "360 Feedback" },
      { href: "/blog/kategori/ik-trendleri", label: "İK Trendleri" },
    ],
    onboarding: [
      { href: "/cozumler/teklif-yonetimi", label: "Teklif Yönetimi" },
      { href: "/cozumler/zimmet-yonetimi", label: "Zimmet Yönetimi" },
      {
        href: "/blog/dijital-ik-donusumu-rehberi",
        label: "Dijital İK Rehberi",
      },
    ],
    "avans-finans": [
      {
        href: "/araclar/isveren-maliyeti-hesaplayici",
        label: "İşveren Maliyeti Hesaplayıcı",
      },
      {
        href: "/araclar/gelir-vergisi-hesaplayici",
        label: "Gelir Vergisi Hesaplayıcı",
      },
      {
        href: "/yazilim/ucret-ve-yan-hak-yonetimi",
        label: "Ücret ve Yan Hak Yönetimi",
      },
    ],
    "360-feedback": [
      { href: "/cozumler/performans-yonetimi", label: "Performans Yönetimi" },
      { href: "/cozumler/analitik", label: "İK Analitik" },
      { href: "/blog/kategori/ik-trendleri", label: "İK Trendleri" },
    ],
    "teklif-yonetimi": [
      { href: "/cozumler/onboarding", label: "Onboarding" },
      { href: "/blog/cv-analizi-nasil-yapilir", label: "CV Analizi Rehberi" },
      {
        href: "/yazilim/ucret-ve-yan-hak-yonetimi",
        label: "Ücret ve Yan Hak Yönetimi",
      },
    ],
    "zimmet-yonetimi": [
      { href: "/cozumler/onboarding", label: "Onboarding" },
      { href: "/sektorler/insaat", label: "İnşaat Sektörü İK" },
      { href: "/cozumler/calisan-yonetimi", label: "Çalışan Yönetimi" },
    ],
  },

  // Araç sayfaları -> İlgili çözümler ve blog
  tool: {
    "izin-hesaplayici": [
      { href: "/cozumler/izin-yonetimi", label: "İzin Yönetimi Çözümü" },
      { href: "/yazilim/izin-takip-programi", label: "İzin Takip Yazılımı" },
      { href: "/blog/izin-yonetimi-rehberi", label: "İzin Rehberi" },
    ],
    "maas-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/yazilim/bordro-yazilimi", label: "Bordro Yazılımı" },
      { href: "/araclar/agi-hesaplayici", label: "AGİ Hesaplayıcı" },
    ],
    "ise-alim-suresi-hesaplayici": [
      { href: "/cozumler/ise-alim", label: "İşe Alım Çözümü" },
      { href: "/yazilim/ats-yazilimi", label: "ATS Yazılımı" },
      {
        href: "/blog/ise-alim-surecini-hizlandirmanin-10-yolu",
        label: "Hızlı İşe Alım Rehberi",
      },
    ],
    "ihbar-suresi-hesaplayici": [
      { href: "/cozumler/calisan-yonetimi", label: "Çalışan Yönetimi" },
      {
        href: "/araclar/kidem-tazminati-hesaplayici",
        label: "Kıdem Tazminatı Hesaplayıcı",
      },
    ],
    "agi-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
    ],
    "fazla-mesai-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
      {
        href: "/araclar/kidem-tazminati-hesaplayici",
        label: "Kıdem Tazminatı Hesaplayıcı",
      },
    ],
    "gelir-vergisi-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
      {
        href: "/araclar/fazla-mesai-hesaplayici",
        label: "Fazla Mesai Hesaplayıcı",
      },
    ],
    "isveren-maliyeti-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
      {
        href: "/araclar/gelir-vergisi-hesaplayici",
        label: "Gelir Vergisi Hesaplayıcı",
      },
    ],
    "kidem-tazminati-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      {
        href: "/araclar/ihbar-suresi-hesaplayici",
        label: "İhbar Süresi Hesaplayıcı",
      },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
    ],
    "maas-zammi-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
      {
        href: "/araclar/gelir-vergisi-hesaplayici",
        label: "Gelir Vergisi Hesaplayıcı",
      },
    ],
    "kurumlar-vergisi-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      {
        href: "/araclar/gelir-vergisi-hesaplayici",
        label: "Gelir Vergisi Hesaplayıcı",
      },
      {
        href: "/araclar/isveren-maliyeti-hesaplayici",
        label: "İşveren Maliyeti Hesaplayıcı",
      },
    ],
    "yemek-ucreti-hesaplayici": [
      { href: "/cozumler/bordro", label: "Bordro Yönetimi" },
      { href: "/araclar/maas-hesaplayici", label: "Maaş Hesaplayıcı" },
      {
        href: "/araclar/isveren-maliyeti-hesaplayici",
        label: "İşveren Maliyeti Hesaplayıcı",
      },
    ],
  },

  // Karşılaştırma sayfaları -> Hub ve ilgili
  comparison: {
    default: [
      { href: "/yazilim/ik-yazilimi", label: "İK Yazılımı Rehberi" },
      { href: "/pricing", label: "IKAI Fiyatlandırma" },
    ],
  },

  // Sektör sayfaları -> Çözümler
  industry: {
    uretim: [
      { href: "/cozumler/mesai-takibi", label: "Mesai Takibi" },
      { href: "/yazilim/puantaj-yazilimi", label: "Puantaj Yazılımı" },
      { href: "/il/sakarya", label: "Sakarya İK Çözümleri" },
    ],
    finans: [
      { href: "/cozumler/analitik", label: "İK Analitik" },
      {
        href: "/yazilim/ucret-ve-yan-hak-yonetimi",
        label: "Ücret ve Yan Hak Yönetimi",
      },
      {
        href: "/araclar/gelir-vergisi-hesaplayici",
        label: "Gelir Vergisi Hesaplayıcı",
      },
    ],
    insaat: [
      { href: "/cozumler/zimmet-yonetimi", label: "Zimmet Yönetimi" },
      { href: "/cozumler/onboarding", label: "Onboarding" },
      { href: "/il/diyarbakir", label: "Diyarbakır İK Çözümleri" },
    ],
    default: [
      { href: "/sektorler", label: "Tüm Sektörler" },
      { href: "/cozumler", label: "Çözümlerimiz" },
      { href: "/pricing", label: "Fiyatlandırma" },
    ],
  },
};

interface RelatedLinksProps {
  pageType:
    | "keyword"
    | "solution"
    | "tool"
    | "comparison"
    | "industry"
    | "blog";
  currentSlug?: string;
  className?: string;
  title?: string;
  maxLinks?: number;
}

export function RelatedLinks({
  pageType,
  currentSlug = "default",
  className = "",
  title = "İlgili Sayfalar",
  maxLinks = 4,
}: RelatedLinksProps) {
  // Sayfa türüne göre linkler
  let links: Array<{ href: string; label: string }> = [];

  switch (pageType) {
    case "keyword":
      // Keyword sayfaları pillar'a bağlı
      links = linkMap.pillar["ik-yazilimi"] || [];
      break;
    case "solution":
      links =
        linkMap.solution[currentSlug as keyof typeof linkMap.solution] || [];
      break;
    case "tool":
      links = linkMap.tool[currentSlug as keyof typeof linkMap.tool] || [];
      break;
    case "comparison":
      links = linkMap.comparison.default;
      break;
    case "industry":
      links =
        linkMap.industry[currentSlug as keyof typeof linkMap.industry] ||
        linkMap.industry.default;
      break;
    case "blog":
      // Blog için varsayılan linkler
      links = [
        { href: "/blog", label: "Tüm Blog Yazıları" },
        { href: "/yazilim", label: "İK Yazılımları" },
        { href: "/cozumler", label: "Çözümlerimiz" },
      ];
      break;
    default:
      links = [];
  }

  // Kendi sayfasına link vermeyi engelle
  links = links.filter((link) => !link.href.includes(currentSlug));

  // Maksimum link sayısını uygula
  links = links.slice(0, maxLinks);

  if (links.length === 0) return null;

  return (
    <div className={`bg-gray-50 rounded-xl p-6 ${className}`}>
      <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-4">
        {title}
      </h3>
      <div className="flex flex-wrap gap-2">
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 hover:border-indigo-300 hover:text-indigo-600 transition-colors"
          >
            {link.label}
            <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default RelatedLinks;
